export default {"src":"/gallery/_next/static/media/rainbow.f1c57a74.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};